import { CircularProgress } from "@mui/material";
import React from "react";
import { Checkbox } from "../../Checkbox/Checkbox";
import { stopPropagation } from "../utils/stopPropagation";
function RowPrefix({ allowSelection, checkboxLabel, isRowLoading, isRowReadOnly, row }) {
    if (isRowLoading) {
        return (React.createElement("div", { style: { display: "flex" } },
            React.createElement(CircularProgress, { style: { margin: "auto 11px", flexShrink: 0 }, size: 25, color: "primary" })));
    }
    else {
        if (allowSelection) {
            return (React.createElement("div", { onClick: stopPropagation, onMouseDown: (e) => {
                    stopPropagation(e);
                    e.preventDefault();
                }, onFocus: stopPropagation, style: { display: "flex", position: "sticky", left: 0, zIndex: 4, backgroundColor: "inherit" } },
                React.createElement(Checkbox, { "data-testid": "grid-row-checkbox", ...row.getToggleRowSelectedProps(), style: { display: "flex" }, indeterminate: false, "aria-label": checkboxLabel, disabled: isRowReadOnly })));
        }
    }
    return null;
}
export default RowPrefix;
